import React, { Fragment, useState } from "react";

const LiveJobSearchInputs = () => {
  const [noValue, setValue] = useState("");
  const [noValueTwo, setValueTwo] = useState("");
  return (
    <Fragment>
      <section className="live-hero">
        <div className="job-search-container">
          <form method="POST" className="form-flex">
            <div className="label-input">
              <label htmlFor="jobtitle" className="labels blue">
                Job Title<i className="fas fa-search mx-5 blue"></i>
              </label>
              <div className="input-drop-down">
                <div className="search-input-hidden">
                  <input
                    className="search-input-style"
                    type="text"
                    name="jobtitle"
                    placeholder="Enter Job Title or Employer Name"
                    onChange={(e) => setValue(e.target.value)}
                  />
                </div>
                {noValue && (
                  <div className="job-location-results">
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Job Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Job Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Job Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Job Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Job Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Job Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Job Result</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="label-input">
              <label htmlFor="location" className="labels blue">
                Location<i className="fas fa-location-arrow blue mx-5"></i>
              </label>
              <div className="input-drop-down">
                <div className="search-input-hidden">
                  <input
                    className="search-input-style"
                    type="text"
                    name="locations"
                    placeholder="Enter City, State or Zip Code"
                    onChange={(e) => setValueTwo(e.target.value)}
                  />
                  <button
                    className="search-button background-blue"
                    type="submit"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
                {noValueTwo && (
                  <div className="job-location-results">
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </section>
    </Fragment>
  );
};

export default LiveJobSearchInputs;
